import { graphql } from "../gql";

export const setWorkflowClaimStatesMutationDoc = graphql(`
  mutation setWorkflowClaimStates($input: SetWorkflowClaimStatesInput!) {
    setWorkflowClaimStates(input: $input) {
      workflowClaimStates {
        batchClaim {
          batchClaimStateById {
            claimAuditType
            clientSignOffClaimState
            determinedAdjustedAllowedAmount
            determinedClientSavings
            determinedDiscrepantAmount
            disputedFindingClaimState
            documentationClaimState
            id
            invoiceClaimState
            isProviderActive
            isRealized
            negotiationClaimState
            onHoldClaimState
            potentialAdjustedAllowedAmount
            potentialClientSavings
            potentialDiscrepantAmount
            providerSignOffClaimState
            reported
            workflowClaimState
          }
          id
        }
      }
    }
  }
`);
